export const BASE_URL       = 'https://www.electronicvillage.org';
export const FACEBOOK_ID    = '1103685064244214'
export const GOOGLE_ID      = '371452236376-r962csltk0fo3e4f75241gm95q6bi15j.apps.googleusercontent.com'
export const USER_HOST      = 'https://evusers.electronicvillage.org'
export const RECAPTCHA      = '6LeEz_0hAAAAALYs3I-jTE3dvdC6JNAWnnD1jUUK'
export const APP_ID         = '31'
